/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Outlook_Select_Folders_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Choose folders to sync..." |
*
* @param {Spaces_Outlook_Select_Folders_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_outlook_select_folders_placeholder = /** @type {((inputs?: Spaces_Outlook_Select_Folders_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Outlook_Select_Folders_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordner zum Synchronisieren auswählen...")
	return /** @type {LocalizedString} */ ("Choose folders to sync...")
});